(function (app) {
  $(document).ready(function () {

    $.fn.textMetrics = function () {
      var el = $(this);

      return {
        'height': el[0].offsetHeight + 20,
        'width': el[0].offsetWidth + 42,
        'padding': '10px 20px',
      };

    };


    app.ImageEditor = function (options) {
      var _this = this;
      _this.options = $.extend({fontSize: {min: 10, max: 500}}, options);
      _this.getUrl = '/api/content/image';
      _this.stepIndex = 1;

      var nameSpace = 'ImageEditor',
        context = '.page__image_editor--context',
        templates = {
          'imageRow': app.templates["Image__editor____row"],
          'layerGroup': app.templates["Image__editor____layer-group"],
          'layerRow': app.templates["Image__editor____layer-row"],
          'fontsDropdown': app.templates["Image__editor____fonts-dropdown"],
          'settingsPopover': app.templates["Image__editor____layer-popover"],
        }
        ;

      _this.initModal = function () {
        _this.modal = $(app.templates["Image__editor____modal"]);
        $('body').append(_this.modal);

        _this.id = _this.modal.assignId();
        _this.$modal = $('#' + _this.id);
        _this.$modal.modal({
          backdrop: 'static',
          keyboard: false
        });
        _this.canvas = $('.editor__canvas', _this.$modal).eq(0);
        _this.canvasWidth = _this.canvas.width();
        _this.canvasHeight = _this.canvas.height();

        if ($('[data-modal-image-manager-full-image]').length == 0) {
          _this.fullImageModal = $(app.templates["Image__manager____modal-full-image"]);
          $('body').append(_this.fullImageModal);
        }

        _this.fullImageModal = $('[data-modal-image-manager-full-image]');

      };

      _this.destroyModal = function () {
        $('[data-modal-image-editor]').remove();
      };

      _this.storage = function () {
        return $.sessionStorage;
      }();

      Math.degrees = function (radians) {
        return radians * 180 / Math.PI;
      };

      _this.pageParams = function () {
        var key = nameSpace + '__pageParams';
        return {
          set: function (params) {
            var pageParams = $.extend({}, _this.storage.get(key), params);
            _this.storage.set(key, pageParams);
          },
          get: function () {
            return _this.storage.get(key);
          },
          clear: function () {
            _this.storage.remove(key);
          }
        }
      };

      _this.destroy = function () {
        _this.destroyModal();
      };

      _this.positionCanvas = function () {
        var minHeight = 350, minWidth = 350, $window = $(window);


        var wH = $window.height(), wW = $window.width();
        var cH = minHeight, cW = minWidth;

        if (wH > 500) {

        }
        //_this.canvas.
      };

      _this.canvasActions = function () {
        return {
          getDimensions: function () {
            var $layerContainer = $('.editor__layers--container', _this.$modal);
            var layout = $layerContainer.attr('data-layout');

            var topCanvas = {
              'w': 1400, 'h': 800
            };

            var layoutCanvas;

            switch (layout) {
              case 'basic' :
                layoutCanvas = {
                  'cl-basic': {'w': topCanvas['w'], 'h': topCanvas['h']}
                };
                break;

              case 'banner_1' :
                layoutCanvas = {
                  'cl-b1-l1': {'w': topCanvas['w'], 'h': topCanvas['h'], x: 0, y: 0},
                  'cl-b1-l2': {
                    'w': topCanvas['w'] / 2,
                    'h': topCanvas['h'] / 2,
                    x: topCanvas['w'] / 4,
                    y: topCanvas['h'] / 4
                  }
                };
                break;

              case 'banner_2' :
                layoutCanvas = {
                  'cl-b2-l1': {'w': topCanvas['w'], 'h': topCanvas['h'], x: 0, y: 0},
                  'cl-b2-l2': {'w': topCanvas['w'] / 2, 'h': topCanvas['h'], x: topCanvas['w'] / 4, y: 0}
                };
                break;

              case 'banner_3' :
                layoutCanvas = {
                  'cl-b3-l1': {'w': topCanvas['w'], 'h': topCanvas['h']},
                  'cl-b3-l2': {'w': topCanvas['w'], 'h': topCanvas['h'] / 2, x: 0, y: topCanvas['h'] / 4}
                };
                break;

              case 'grid_50_50' :
                layoutCanvas = {
                  'cl-g50_50-l1': {'w': topCanvas['w'] / 2, 'h': topCanvas['h'], x: 0, y: 0},
                  'cl-g50_50-l2': {'w': topCanvas['w'] / 2, 'h': topCanvas['h'], x: topCanvas['w'] / 2, y: 0}
                };
                break;

              case 'grid_33_67' :
                layoutCanvas = {
                  'cl-g33_67-l1': {'w': topCanvas['w'] * 0.33, 'h': topCanvas['h'], x: 0, y: 0},
                  'cl-g33_67-l2': {'w': topCanvas['w'] * 0.67, 'h': topCanvas['h'], x: topCanvas['w'] * 0.33, y: 0}
                };
                break;

              case 'grid_67_33' :
                layoutCanvas = {
                  'cl-g67_33-l1': {'w': topCanvas['w'] * 0.67, 'h': topCanvas['h'], x: 0, y: 0},
                  'cl-g67_33-l2': {'w': topCanvas['w'] * 0.33, 'h': topCanvas['h'], x: topCanvas['w'] * 0.67, y: 0}
                };
                break;
            }

            return $.extend({},
              {'main': topCanvas}, layoutCanvas
            )
          },

          getCanvasSize: function () {
            return _this.canvasActions().getDimensions();
          },

          setCanvasSize: function () {
            var $canvasContainer = $('.editor__container', _this.$modal);
            var containerMargin = parseInt($canvasContainer.css('margin-top').replace('px', ''))
              + parseInt($canvasContainer.css('margin-bottom').replace('px', ''))
              + 70;

            var canvasHeight, canvasWidth, newCanvasHeight, newCanvasWidth;
            var mainCanvasHeight = _this.canvasActions().getDimensions()['main']['h'];
            var mainCanvasWidth = _this.canvasActions().getDimensions()['main']['w'];

            var mainNewCanvasHeight = Math.min(mainCanvasHeight, Math.max($(window).outerHeight() - containerMargin, 340));
            var mainNewCanvasWidth = (mainCanvasWidth * mainNewCanvasHeight) / mainCanvasHeight;
            $canvasContainer.width(
              mainNewCanvasWidth
            ).height(
              mainNewCanvasHeight
            );

            _.each(_this.canvasActions().getDimensions(), function (value, key) {
              canvasHeight = _this.canvasActions().getDimensions()[key]['h'];
              canvasWidth = _this.canvasActions().getDimensions()[key]['w'];

              if (key == 'main') {

              } else {
                newCanvasHeight = mainNewCanvasHeight * canvasHeight / mainCanvasHeight;
                newCanvasWidth = (canvasWidth * newCanvasHeight) / canvasHeight;
                $canvasContainer = $('.editor__canvas[data-layout="' + key + '"]', _this.$modal);
                $canvasContainer.width(
                  newCanvasWidth
                ).height(
                  newCanvasHeight
                );
              }
            });

          }
        }
      };

      _this.getDraggablePosition = function ($el) {
        var $draggable = $('.acre__draggable#' + $el.attr('data-row'));
        var $canvasContainer = $('.editor__container', _this.$modal);
        var $draggableCanvas = $draggable.closest('.editor__canvas');

        var angle = typeof $draggable.attr('data-angle') == 'undefined' ? 0 : Math.floor(parseFloat($draggable.attr('data-angle')))

        var x = parseFloat($draggable.css('left').replace('/px', ''));
        var y = parseFloat($draggable.css('top').replace('/px', ''));

        var w = parseFloat($draggable.css('width').replace('/px', ''));
        var h = parseFloat($draggable.css('height').replace('/px', ''));

        var cw = parseFloat($draggableCanvas.css('width').replace('/px', ''));
        var ch = parseFloat($draggableCanvas.css('height').replace('/px', ''));

        var cd = _this.canvasActions().getCanvasSize()[$draggableCanvas.attr('data-layout')];

        var rW = w * cd['w'] / cw;
        var rH = h * rW / w;

        var rX = x * cd['w'] / cw;
        var rY = y * cd['h'] / ch;

        var data;
        if ($draggable.hasClass('acre__image')) {
          var image = $draggable.find('img').attr('src');
          data = {
            'type': 'image',
            'image': image,
            'width': Math.floor(rW),
            'height': Math.floor(rH),
            'x': Math.floor(rX),
            'y': Math.floor(rY),
            'angle': angle
          };
        }

        if ($draggable.hasClass('acre__text--wrapper')) {
          var $text = $draggable.find('.acre__text');
          data = _this.getTextSettings($text);
          var text = $text.html();
          text = text.replace(/<div>/ig, "\n").replace(/<\/div>/ig, "").replace(/&nbsp;/g, '');

          var fontPath = $('select[name="editor__fonts"] option[value="' + data.fontFamily + '"]', _this.$modal);
          var fontGroupFolder = fontPath.closest('optgroup').attr('label');
          var fontFolder = data.fontFamily.replace(/\s/g, '_').replace(/,/g, '');
          var fontName = data.fontFamily.replace(/\s/g, '').replace(/,/g, '') + '-Regular.ttf';

          var $textClone = $text.clone().css({'visibility': 'hidden'}).appendTo(_this.$modal);
          data.fontFamily = fontGroupFolder + '/' + fontFolder + '/' + fontName;
          data.fontSize += (data.fontSize * 0.20);

          $textClone.remove();
          data = $.extend(data, {
            'type': 'text',
            'width': Math.floor(rW),
            'height': Math.floor(rH),
            'x': Math.floor(rX),
            'y': Math.floor(rY),
            'angle': angle,
            'text': text,
          });
        }
        return data;

      };

      _this.prepareRequest = function (requestData) {
        var imageId = $(':input[name=id]', _this.$modal).val();
        if (imageId != '') {
          requestData = $.extend(requestData, {id: imageId});
        }

        _this.saveSessionData();
        requestData = $.extend(requestData, {'canvasData': _this.pageParams().get()});

        return [requestData];
      };

      _this.initColorPicker = function () {
        $('[data-colorpicker]', _this.$modal).each(function () {
          $(this).assignId();
        });

        $('[data-colorpicker]', _this.$modal).colorpicker({
          useAlpha: false, format: 'hex',
          component: '.input-group-append .input-group-text',
        })
          .on('colorpickerChange colorpickerCreate', function (e) {
            $(this).find('input[name="text-color"]').trigger('changeColor');
          });
      };

      _this.initPopoverAndRangeSlider = function () {
        $('[data-toggle="popover"]', _this.$modal).popover({html: true, container: _this.$modal});

        $('[data-toggle="popover"]', _this.$modal).on('show.bs.popover', function (e) {
          var popoverId = $(this).attr('aria-describedby');
          $('.popover', _this.$modal).each(function () {
            if ($(this).attr('id') != popoverId) {
              $(this).remove();
            }
          });

          var $fontsDropdown = $('.editor__fonts--dropdown', _this.$modal);
          if ($fontsDropdown.find('.dropdown-menu.show').length) {
            $fontsDropdown.find('.dropdown-toggle').trigger('click');
          }

        }).on('shown.bs.popover', function (e) {
          var popoverId = $(this).attr('aria-describedby');
          var $popover = $('#' + popoverId);

          $('input[type="range"]', $popover).val($(this).attr('data-val'));

          $('input[type="range"]', $popover).rangeslider({
            polyfill: false,

            // Default CSS classes
            rangeClass: 'rangeslider',
            disabledClass: 'rangeslider--disabled',
            horizontalClass: 'rangeslider--horizontal',
            verticalClass: 'rangeslider--vertical',
            fillClass: 'rangeslider__fill',
            handleClass: 'rangeslider__handle',
            // Callback function
            onInit: function () {
              var input = $(this)[0].$element;
              var container = input.closest('.range__container');
              var value = input.val();
              var dataRange = container.find(':input[data-range]');
              dataRange.val(value).trigger('slideChange');
            },

            // Callback function
            onSlide: function (position, value) {
              var input = $(this)[0].$element;
              var container = input.closest('.range__container');
              var dataRange = container.find(':input[data-range]');
              dataRange.val(value).trigger('slideChange');
            },

            // Callback function
            onSlideEnd: function (position, value) {
            }
          });
        });
      };
      _this.createFontsDropDown = function () {
        _this.loadGoogleFonts();
        var $dropDown = $('select[name="editor__fonts"]').next();
        var $toggle = $('.dropdown-toggle', $('.editor__fonts--dropdown'));

        $('select[name="editor__fonts"] optgroup', _this.$modal).each(function () {
          var optGroup = $(this).attr('label');
          var fontsDropdown = _.template(templates.fontsDropdown);
          var $fontsDropdown = $(
              fontsDropdown({
                'optGroup': optGroup
              })
            )
            ;

          $fontsDropdown.appendTo($dropDown).find('.card-title').css({'font-family': $(this).attr('data-val')});
          var $collapseBody = $fontsDropdown.find('.card-body');
          $('option', $(this)).each(function () {
            var font = $(this).val().replace(', sans-serif', '').replace(', serif', '').replace("'", '').replace("'", '');
            var $button = $('<button class="dropdown-item btn btn-default"></button>').css({'font-family': font}).text(font).attr('data-font', $(this).val());
            $button.appendTo($collapseBody);
          });

        });

        var $defaultOption = $('select[name="editor__fonts"] option', _this.$modal).eq(0);
        var font = $defaultOption.val().replace(', sans-serif', '').replace(', serif', '').replace("'", '').replace("'", '');
        var $span = $('<span> </span>').css({'font-family': font}).text(font);
        $toggle.html($span);

        $(document).off('click.editor__fonts--dropdown' + nameSpace).on('click.editor__fonts--dropdown' + nameSpace, '.editor__fonts--dropdown .dropdown-item', function (e) {
          e.preventDefault();
          var font = $(this).attr('data-font');
          var $toggle = $('.dropdown-toggle', $('.editor__fonts--dropdown'));
          $toggle.find('span').css({'font-family': font}).text(font);
          $('select[name="editor__fonts"] option[value="' + font + '"]', _this.$modal).prop('selected', true).trigger('fontChange');
        });

        $(document).off('change.editor__fonts--select' + nameSpace).on('change.editor__fonts--select' + nameSpace, 'select[name="editor__fonts"]', function (e) {
          e.preventDefault();
          var font = $(this).val();
          var $toggle = $('.dropdown-toggle', $('.editor__fonts--dropdown'));
          $toggle.find('span').css({'font-family': font}).text(font);
        });

        $('.editor__fonts--dropdown', _this.$modal).on('shown.bs.dropdown', function () {
          $('.popover', _this.$modal).remove();
        })
      };

      _this.loadGoogleFonts = function () {
        var fontFamilies = [];

        $('select[name="editor__fonts"] optgroup[label!="System"] option', _this.$modal).each(function () {
          var font = $(this).val();
          fontFamilies.push(font);
        });

        if (fontFamilies.length) {
          WebFontConfig = {
            google: {families: fontFamilies}
          };

          (function () {
            var wf = document.createElement('script');
            wf.src = ('https:' == document.location.protocol ? 'https' : 'http') +
              '://ajax.googleapis.com/ajax/libs/webfont/1.5.18/webfont.js?' + Date.now();
            wf.type = 'text/javascript';
            wf.async = 'true';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(wf, s);
          })();
        }
      };

      _this.applyNewFontSize = function ($text, width, height) {
        _this.calculateFontSize($text, width, height);
      };

      _this.calculateFontSize = function ($text, width, height) {
        var fontSize;
        for (var i = _this.options['fontSize']['min']; i < _this.options['fontSize']['max']; i++) {
          $text.css('font-size', i + 'px');
          if (($text.height() >= height ) || ( $text.width() >= width)) {
            fontSize = i;
            break;
          }
        }
        return fontSize;
      };

      _this.setFontSize = function (ui, originalFontSize) {

        var $draggable = $(ui.helper);
        var nW = ui.size['width'];
        var nH = ui.size['height'];
        var $text = $draggable.find('.acre__text');
        $text.css({'white-space': 'nowrap', 'display': 'table'});
        _this.applyNewFontSize($text, nW, nH);
        _this.setDraggableBound($draggable);

      };

      _this.setDraggableBound = function ($draggable) {
        var dataId = $draggable.attr('id');

        var $text = $draggable.find('.acre__text');

        var textMetrics = $text.textMetrics();
        $draggable.css(textMetrics);

        $('.image-editor-layer-row[data-row="' + dataId + '"]').find('.col__name').text($(this).text());
        $('.editor__control[data-id=' + dataId + ']', _this.$modal).attr('style', $draggable.attr('style'));
      };

      _this.addDraggable = function (type, data) {

        var $draggable, draggableId;
        if (type == 'text') {
          var $text = $('<div class="acre__text" spellcheck="false"> </div> ');
          $text.html(data.text);
          $draggable = $('<div > </div>').addClass('acre__draggable acre__text--wrapper');
          $text.appendTo($draggable);
          $draggable.appendTo(_this.canvas);
          _this.setTextStyleFromEditor($text);
          $draggable.css('width', $draggable.width()).css('height', $draggable.outerHeight());
          $draggable.css('left', (_this.canvas.width() - $draggable.width()) / 2)
            .css('top', (_this.canvas.height() - $draggable.height()) / 2);
        }
        if (type == 'image') {
          var imageWidth = parseInt($.trim(data.images[0]['dimensions'].split('x')[0]));
          var imageHeight = parseInt($.trim(data.images[0]['dimensions'].split('x')[1]));

          var imageType = _.isUndefined(data.images[0]['type']) ? 'image' : data.images[0]['type'];

          data.images[0].path = data.images[0].path.indexOf('html2canvasproxy.php') < 0 ? '/html2canvasproxy.php?url=' + data.images[0].path + '&responseType=blob' : data.images[0].path;
          var $image = $('<img />')
              .attr('src', data.images[0]['pathThumbnail'])
              .attr('data-src', data.images[0]['path']).css({
                'width': '100%',
                'max-height': '100%'
              }).addClass('lazy')
              .attr('data-width', imageWidth)
              .attr('data-height', imageHeight)
              .attr('data-thumbnail', data.images[0]['pathThumbnail'])
              .attr('data-path', data.images[0]['path'])
              .attr('data-type', imageType)
            ;
          $draggable = $('<div > </div>').addClass('acre__draggable m-progress acre__image').attr({}).addClass('acre__' + imageType);
          var newImageWidth, newImageHeight;
          if (typeof  data.originalWidth != 'undefined') {
            newImageWidth = data.originalWidth;
            newImageHeight = (imageHeight * newImageWidth) / imageWidth;

            $draggable.css('top', data.originalTop);
            $draggable.css('left', data.originalLeft);
          } else if (imageType == 'image') {
            newImageWidth = Math.min(imageWidth, $('.editor__container', _this.$modal).width());
            newImageHeight = (imageHeight * newImageWidth) / imageWidth;
          } else if (imageType == 'logo') {
            newImageWidth = Math.min(100, $('.editor__container', _this.$modal).width());
            newImageHeight = (imageHeight * newImageWidth) / imageWidth;

            $draggable.css('top', 25);
            $draggable.css('left', 25);
          }

          $draggable.css('width', newImageWidth)
            .css('height', newImageHeight);
          $image.appendTo($draggable);


          if (typeof data.background != 'undefined') {
            $draggable.addClass('acre__background--image');
            $draggable.insertAfter(_this.canvas.find('.acre__background--block'));
          } else {
            $draggable.appendTo(_this.canvas);
          }

        }

        if (type == 'background-block') {
          $draggable = $('<div > </div>').addClass('acre__draggable acre__background--block');
          _this.canvas = $('.editor__canvas[data-layout="' + data.layerGroup + '"]');
          $draggable.prependTo(_this.canvas);
          $draggable.css({'width': '100%', 'height': '100%', 'background-color': '#ffffff'});
        }

        draggableId = $draggable.assignId();
        $draggable.attr('data-type', type);

        if (type == 'text' || type == 'image') {
          var $editorControl = $('.editor__control--template').clone();
          var $editorControlExist = $('.editor__control[data-id="' + draggableId + '"]');
          if ($editorControlExist.length) $editorControlExist.remove();
          $editorControl.removeClass('editor__control--template').addClass('editor__control').attr('data-id', draggableId);
          $editorControl.appendTo($('.editor__container', _this.$modal));
          var $neHandle = $editorControl.find('.ui-resizable-ne');
          var $seHandle = $editorControl.find('.ui-resizable-se');
          var $swHandle = $editorControl.find('.ui-resizable-sw');
          var $nwHandle = $editorControl.find('.ui-resizable-nw');
          var $rotateHandle = $editorControl.find('.ui-rotatable-handle');

          $draggable.rotatable({
            wheelRotate: false,
            handle: $rotateHandle, rotate: function (ui, angle) {
              var dataId = $(this).attr('id');
              _this.setPositionForEditorControl(dataId, $(this));
            },
            stop: function (event, ui) {
              var angle = Math.degrees(ui.angle.stop);
              angle = angle < 0 ? 360 + angle : angle;
              angle = parseInt(angle);
              $(ui.element).attr('data-angle', angle);
            },
          });

          $draggable.resizable({
            delay: 0,
            handles: {
              'ne': $neHandle,
              'se': $seHandle,
              'sw': $swHandle,
              'nw': $nwHandle,
            },
            aspectRatio: type == 'image',
            resize: function (event, ui) {
              var dataId = ui.helper.attr('id');
              var isText = $(ui.helper).hasClass('acre__text--wrapper');
              if (isText) {
                _this.setFontSize(ui);
              }
              _this.setPositionForEditorControl(dataId, $(ui.helper));
            },

          });

          $editorControl.draggable({
            delay: 300,
            create: function (event, ui) {
              _this.setPositionForEditorControl(draggableId, $draggable, false);
            },
            drag: function (event, ui) {
              var dataId = ui.helper.attr('data-id');
              _this.setPositionForDraggable(dataId, $(this));
            },
            start: function (event, ui) {

            },
            stop: function (event, ui) {
              var dataId = ui.helper.attr('data-id');
              _this.setPositionForDraggable(dataId, $(this));
            }
          });
        }

        var layerRow = _.template(templates.layerRow);
        var layerRowNameField;
        if (type == 'text') {
          layerRowNameField = data.text;
        }
        else if (type == 'image') {
          layerRowNameField = '<img src="' + data.images[0]['pathThumbnail'] + '" data-path="' + data.images[0]['path'] + '" class="lazy img-responsive" />'
        }
        else if (type == 'background-block') {
          layerRowNameField = '';
        }
        var $layerRow = $(
          layerRow(
            $.extend(data, {
              background: typeof data.background == 'undefined' ? false : data.background,
              id: draggableId,
              type: type,
              name: layerRowNameField,
            })
          )
        );

        if (type == 'background-block') {
          $layerRow.find('.col__name').css({
            'background-color': '#ffffff',
            'opacity': 1
          });
        }

        var layerName = _this.canvas.attr('data-layout');
        var $layersTable = $('.table__layers-body.' + layerName, _this.$modal);
        if (data.background == false) {
          $layerRow.prependTo($layersTable);
        } else {
          $layerRow.appendTo($('.table__layers-foot.' + layerName, _this.$modal));
        }
        $layersTable.sortable('refresh');

        app.lazyLoadImage(_this.canvas, function (el) {
          var dataId = $(el).closest('.acre__image').attr('id');
          $('.image-editor-layer-row[data-row="' + dataId + '"]').find('.col__name').removeClass('m-progress');
        });

        _this.setZIndexForDraggable();
        return $draggable;

      };

      _this.removeDraggable = function (id) {
        $('#' + id).remove();
      };

      _this.addText = function () {
        var $draggable = _this.addDraggable('text', {'text': 'Double click to edit :: ' + (_this.stepIndex++)});
        _this.setDraggableBound($draggable);
      };

      _this.saveSessionData = function () {
        _this.extractTextData = function ($el) {
          var $text = $el.find('.acre__text');
          return {
            'text': $text.html(),
            'css': $text.attr('style'),
          }
        };
        _this.extractImageData = function ($el) {
          var $image = $el.find('img');
          return {
            'images': [
              {
                'dimensions': $image.attr('data-width') + " x " + $image.attr('data-height'),
                'pathThumbnail': $image.attr('data-thumbnail'),
                'path': $image.attr('data-path'),
              }
            ],
            'css': $image.attr('style'),
          }
        };

        _this.extractData = function ($el) {
          var type = $el.attr('data-type');
          switch (type) {
            case 'text' :
              return _this.extractTextData($el);
              break;
            case 'image' :
              return _this.extractImageData($el);
              break;
            case 'background-block' :
              return {
                'prepend': true,
                'background': true,
                'layerGroup': $el.closest('.editor__canvas').attr('data-layout')
              };
              break;
          }
        };

        var sessionData = {'layout': $('.editor__layers--container', _this.$modal).attr('data-layout')};
        $('.table__layers-list', _this.$modal).each(function (layerIndex) {
          layerIndex = 'layer_' + layerIndex;
          sessionData[layerIndex] = {};
          var $layerGroup = $(this);
          $('.image-editor-layer-row', $layerGroup).each(function (stepIndex) {
            var zIndex = $(this).attr('data-zIndex');
            var rowId = $(this).attr('data-row');
            var $draggable = $('.acre__draggable#' + rowId);
            sessionData[layerIndex][zIndex] = {
              'id': rowId,
              'type': $draggable.attr('data-type'),
              'background': $(this).hasClass('tr-background'),
              'css': $draggable.attr('style'),
              'data': _this.extractData($draggable)
            };

            if (sessionData[layerIndex][zIndex].background) {
              var layerInfo = _this.BackgroundLayerRow().extractLayerInfo($layerGroup);
              sessionData[layerIndex][zIndex].data = $.extend({}, sessionData[layerIndex][zIndex].data, {
                'prepend': true,
                'background': layerInfo['background']
              })
            }
          });
        });
        _this.pageParams().set(sessionData);
      };

      _this.rgba2hex = function (color_value) {
        if (!color_value) return false;
        var parts = color_value.toLowerCase().match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/),
          length = color_value.indexOf('rgba') ? 3 : 2; // Fix for alpha values
        delete(parts[0]);
        for (var i = 1; i <= length; i++) {
          parts[i] = parseInt(parts[i]).toString(16);
          if (parts[i].length == 1) parts[i] = '0' + parts[i];
        }
        return '#' + parts.join('').toLowerCase();
      };

      _this.BackgroundLayerRow = function () {
        return {
          checkAndCreateDefaultColorBlock: function ($layerGroup) {
            var $backGroundLayer = $layerGroup.find('.tr-background');
            var $draggable;
            if ($backGroundLayer.length) {
              $draggable = $('.editor__canvas[data-layout="' + $layerGroup.attr('data-layout') + '"]').find('.acre__background--block');
            } else {
              $draggable = _this.addDraggable('background-block', {
                'background': true, 'prepend': true, 'layerGroup': $layerGroup.attr('data-layout')
              });
            }
            ;

            var bc = $draggable.css('background-color'), opacity = $draggable.css('opacity');
            _this.BackgroundLayerRow().setLayerInfo($layerGroup, {background: {color: bc, opacity: opacity}});
            return $draggable;
          },

          deleteDefaultColorBlock: function ($layerGroup) {
            var $backGroundLayer = $layerGroup.find('.tr-background');
            $backGroundLayer.remove();
          },

          extractLayerInfo: function ($layerGroup) {
            var layerInfo = {};
            var $backGroundLayer = $layerGroup.find('.tr-background');
            var $nameColumn = $backGroundLayer.find('.col__name');
            var hasBackgroundImage = $nameColumn.find('img');
            layerInfo['background'] = {
              'color': _this.rgba2hex($nameColumn.css('background-color')),
              'opacity': $nameColumn.css('opacity')
            };
            if (hasBackgroundImage.length) {

              layerInfo['images'] = [
                $.extend(
                  {
                    'pathThumbnail': hasBackgroundImage.attr('src'),
                    'path': hasBackgroundImage.attr('data-path')
                  }, _this.getDraggablePosition($backGroundLayer)
                )
              ];
            }

            return layerInfo;
          },

          setLayerInfo: function ($layerGroup, data) {
            var $nameColumn = $layerGroup.find('.tr-background').find('.col__name');
            var $backgroundImage = $nameColumn.find('img');
            var backgroundCss = {
              'background-color': data.background['color'],
              'opacity': data.background['opacity']
            };
            var originalCss = {
              'background-color': $nameColumn.css('background-color'),
              'opacity': $nameColumn.css('opacity'),
            };
            backgroundCss = $.extend(originalCss, backgroundCss);
            $nameColumn.css(
              backgroundCss
            );
            var $canvas = $('.editor__canvas[data-layout="' + $layerGroup.attr('data-layout') + '"]');
            $canvas.find('.acre__background--block').css(backgroundCss);
            $canvas.find('.acre__background--image').css(backgroundCss);
          }
        }

      };

      _this.restoreFromSessionData = function () {
        var sessionData = _this.pageParams().get();
        $('.table__layers-list', _this.$modal).each(function (layerIndex) {
          layerIndex = 'layer_' + layerIndex;
          var layout = $(this).attr('data-layout');
          if (!_.isEmpty(sessionData) && typeof sessionData[layerIndex] != 'undefined') {
            var layerData = sessionData[layerIndex];
            _this.canvas = $('.editor__canvas[data-layout="' + layout + '"]');
            var $layerGroup = $('.table__layers-list[data-layout="' + layout + '"]');
            _.each(layerData, function (row, zIndex) {
              var $draggable;
              if (row.background == false) {
                $draggable = _this.addDraggable(row.type, row.data);
                if (typeof  row.css != 'undefined') {
                  $draggable.attr('style', row.css);
                }
                if (row.type == 'text') {
                  $draggable.find('.acre__text').attr('style', row.data.css);
                }
              } else {
                if (typeof row.data['images'] == 'undefined') {
                  $draggable = _this.BackgroundLayerRow().checkAndCreateDefaultColorBlock($layerGroup);
                } else {
                  _this.BackgroundLayerRow().deleteDefaultColorBlock($layerGroup);
                  $draggable = _this.addDraggable(row.type, row.data);
                }
                _this.BackgroundLayerRow().setLayerInfo($layerGroup, row.data);
                if (typeof  row.css != 'undefined') {
                  $draggable.attr('style', row.css);
                }
              }
            });
          }
        });
      };

      _this.setZIndexForDraggable = function () {
        $('.editor__canvas', _this.$modal).each(function (layerIndex) {
          $('.acre__draggable', $(this)).each(function (stepIndex) {

            var zIndex = ((layerIndex + 1) * 100) + $(this).index();
            var rowId = $(this).attr('id');
            var $draggable = $('.acre__draggable#' + rowId);
            if ($draggable.length) {
              $draggable.css({'z-index': zIndex});
            }
            var $imageLayer = $('.image-editor-layer-row[data-row="' + rowId + '"]');
            $imageLayer.attr('data-zIndex', zIndex);
          });
        });
      };


      _this.setZIndexForDraggableFromLayers = function () {
        $('.editor__layers--container .table__layers-list', _this.$modal).each(function (layerIndex) {
          var count = $('.image-editor-layer-row', $(this)).length;
          $('.image-editor-layer-row', $(this)).each(function (stepIndex) {
            var $imageLayer = $(this);

            var zIndex = ((layerIndex + 1) * 100) + (count - stepIndex );
            var rowId = $(this).attr('data-row');
            var $draggable = $('.acre__draggable#' + rowId);

            if ($draggable.length) {
              $draggable.css({'z-index': zIndex});
            }

            $imageLayer.attr('data-zIndex', zIndex);
          });
        });
      };

      _this.addImage = function (data) {
        _this.addDraggable('image', data);
      };


      _this.setTextStyleFromEditor = function ($text) {
        var font = $('select[name=editor__fonts]', _this.$modal).val();
        var $fontSize = $(':input[name="editor__font-size"]', _this.$modal);
        var fontSize = $fontSize.length ? $fontSize.val() : 30;
        var textColor = $(':input[name="text-color"]', _this.$modal).val();
        var fontBold = $(':input[name="font__bold"]', _this.$modal).hasClass('active') ? 'bold' : 'normal';
        var fontItalic = $(':input[name="font__italic"]', _this.$modal).hasClass('active') ? 'italic' : 'normal';
        var fontUnderline = $(':input[name="font__underline"]', _this.$modal).hasClass('active') ? 'underline' : 'none';

        var $fontLineHeight = $(':input[name="editor__font-line-height"]', _this.$modal);
        var lineHeight = $fontLineHeight.length ? $fontLineHeight.val() : '1.6';

        var $letterSpacing = $(':input[name="editor__font-letter-spacing"]', _this.$modal);
        var letterSpacing = $letterSpacing.length ? $letterSpacing.val() : 0;

        var $btnAlign = $('.btn-align.active', _this.$modal);
        var align = $btnAlign.length ? $btnAlign.attr('data-align') : 'left';

        var $css = {
          'font-family': font,
          'font-size': fontSize,
          'color': textColor,
          'font-weight': fontBold,
          'font-style': fontItalic,
          'text-decoration': fontUnderline,
          'line-height': lineHeight,
          'letter-spacing': letterSpacing,
          'text-align': align
        };

        $text.css($css);

      };

      _this.setEditorSettingsFromText = function ($text) {
        var textSettings = _this.getTextSettings($text);

        var $bold = $(':input[name="font__bold"]', _this.$modal);
        var $italic = $(':input[name="font__italic"]', _this.$modal);
        var $underline = $(':input[name="font__underline"]', _this.$modal);

        $('select[name=editor__fonts]', _this.$modal).val(textSettings.fontFamily).trigger('change');
        $('button.editor__fonts--size', _this.$modal).attr('data-val', textSettings.fontSize);
        $(':input[name="text-color"]', _this.$modal).val(textSettings.color).trigger('change');
        textSettings.bold ? $bold.addClass('active') : $bold.removeClass('active');
        textSettings.italic ? $italic.addClass('active') : $italic.removeClass('active');
        textSettings.underline ? $underline.addClass('active') : $underline.removeClass('active');
        $('.btn-align', _this.$modal).removeClass('active');
        $('.btn-align[data-align="' + textSettings.textAlign + '"]').addClass('active');
        $('button.editor__line-height', _this.$modal).attr('data-val', textSettings.lineHeight);
        $('button.editor__letter-spacing', _this.$modal).attr('data-val', textSettings.letterSpacing);
      };

      _this.getTextSettings = function ($text) {
        var fontSize = parseFloat($text.css('font-size').replace('/px', ''));
        var fontFamily = $text.css('font-family').replace(new RegExp('"', 'g'), '');
        var textAlign = $text.css('text-align');
        var lineHeight = parseFloat($text.css('line-height').replace('/px', ''));
        var letterSpacing = parseFloat($text.css('letter-spacing').replace('/px', ''));
        var color = _this.rgba2hex($text.css('color'));
        var bold = $text.css('font-weight') == 'bold' || $text.css('font-weight') == 700;
        var italic = $text.css('font-style') == 'italic';
        var underline = $text.css('text-decoration').indexOf('underline') >= 0;

        return {
          'fontSize': fontSize,
          'fontFamily': fontFamily,
          'textAlign': textAlign,
          'lineHeight': lineHeight / fontSize,
          'letterSpacing': letterSpacing,
          'color': color,
          'bold': bold,
          'italic': italic,
          'underline': underline
        }
      };

      _this.setLayout = function (layout) {

        $('[data-layout]', _this.$modal).removeClass('active');
        $('[data-layout="' + layout + '"]', _this.$modal).addClass('active');
        _this.saveSessionData();
        var $canvasContainer = $('.editor__canvas--container', _this.$modal);
        $canvasContainer.find('*').remove();

        var $layerContainer = $('.editor__layers--container', _this.$modal);
        $layerContainer.find('*').remove();

        $layerContainer.attr('data-layout', layout);

        $('.editor__control', _this.$modal).remove();

        var settingsPopover = _.template(templates.settingsPopover);
        var $settingsButton = $('<button class="btn btn-transparent btn-canvas-setting" data-toggle="popover" data-placement="bottom"> <i class="fas fa-cog"></i> </button>');
        $settingsButton.attr('data-content', settingsPopover);

        var $layer, $layer2, $layer1;
        switch (layout) {
          case 'basic' :
            $layer = $('<div data-layout="cl-basic"> ' +
              ' </div>').addClass('editor__canvas cl-basic');
            $layer.appendTo($canvasContainer);

            _this.canvas = $layer;
            _this.createLayerGroup('cl-basic').addClass('active');
            _this.restoreFromSessionData();
            break;

          case 'banner_1' :
            $layer1 = $('<div data-layout="cl-b1-l1"> </div>').addClass('editor__canvas cl-b1-l1');
            $layer2 = $('<div data-layout="cl-b1-l2"> </div>').addClass('editor__canvas cl-b1-l2');
            $layer1.appendTo($canvasContainer);
            $layer2.appendTo($canvasContainer);
            _this.canvas = $layer2;

            _this.createLayerGroup('cl-b1-l1');
            _this.createLayerGroup('cl-b1-l2').addClass('active');
            _this.restoreFromSessionData();

            break;

          case 'banner_2' :
            $layer1 = $('<div data-layout="cl-b2-l1"> </div>').addClass('editor__canvas cl-b2-l1');
            $layer2 = $('<div data-layout="cl-b2-l2"> </div>').addClass('editor__canvas cl-b2-l2');
            $layer1.appendTo($canvasContainer);
            $layer2.appendTo($canvasContainer);
            _this.canvas = $layer2;

            _this.createLayerGroup('cl-b2-l1');
            _this.createLayerGroup('cl-b2-l2').addClass('active');
            _this.restoreFromSessionData();
            break;

          case 'banner_3' :
            $layer1 = $('<div data-layout="cl-b3-l1"> </div>').addClass('editor__canvas cl-b3-l1');
            $layer2 = $('<div data-layout="cl-b3-l2"> </div>').addClass('editor__canvas cl-b3-l2');
            $layer1.appendTo($canvasContainer);
            $layer2.appendTo($canvasContainer);

            _this.canvas = $layer2;

            _this.createLayerGroup('cl-b3-l1');
            _this.createLayerGroup('cl-b3-l2').addClass('active');
            _this.restoreFromSessionData();
            break;

          case 'grid_50_50' :
            $layer1 = $('<div data-layout="cl-g50_50-l1"> </div>').addClass('editor__canvas cl-g50_50-l1');
            $layer2 = $('<div data-layout="cl-g50_50-l2"> </div>').addClass('editor__canvas cl-g50_50-l2');
            $layer1.appendTo($canvasContainer);
            $layer2.appendTo($canvasContainer);

            _this.canvas = $layer2;

            _this.createLayerGroup('cl-g50_50-l1');
            _this.createLayerGroup('cl-g50_50-l2').addClass('active');
            _this.restoreFromSessionData();

            break;

          case 'grid_33_67' :
            $layer1 = $('<div data-layout="cl-g33_67-l1"> </div>').addClass('editor__canvas cl-g33_67-l1');
            $layer2 = $('<div data-layout="cl-g33_67-l2"> </div>').addClass('editor__canvas cl-g33_67-l2');
            $layer1.appendTo($canvasContainer);
            $layer2.appendTo($canvasContainer);

            _this.canvas = $layer2;

            _this.createLayerGroup('cl-g33_67-l1');
            _this.createLayerGroup('cl-g33_67-l2').addClass('active');
            _this.restoreFromSessionData();
            break;

          case 'grid_67_33' :
            $layer1 = $('<div data-layout="cl-g67_33-l1"> </div>').addClass('editor__canvas cl-g67_33-l1');
            $layer2 = $('<div data-layout="cl-g67_33-l2"> </div>').addClass('editor__canvas cl-g67_33-l2');
            $layer1.appendTo($canvasContainer);
            $layer2.appendTo($canvasContainer);

            _this.canvas = $layer2;

            _this.createLayerGroup('cl-g67_33-l1');
            _this.createLayerGroup('cl-g67_33-l2').addClass('active');
            _this.restoreFromSessionData();
            break;
        }
        _this.canvasActions().setCanvasSize();
      };

      _this.setPositionForEditorControl = function (dataId, $draggable, active) {
        active = (typeof active == 'undefined') ? true : active;

        var $draggableCanvas = $draggable.closest('.editor__canvas');
        var left = parseFloat($draggable.css('left').replace('/px', ''));
        var top = parseFloat($draggable.css('top').replace('/px', ''));
        var bottom = parseFloat($draggable.css('bottom').replace('/px', ''));
        var right = parseFloat($draggable.css('right').replace('/px', ''));

        var cleft = parseFloat($draggableCanvas.css('left').replace('/px', ''));
        var ctop = parseFloat($draggableCanvas.css('top').replace('/px', ''));
        var cbottom = parseFloat($draggableCanvas.css('bottom').replace('/px', ''));
        var cright = parseFloat($draggableCanvas.css('right').replace('/px', ''));

        left += cleft;
        top += ctop;

        var $editorControl = $('.editor__control[data-id=' + dataId + ']', _this.$modal);

        $editorControl
          .attr('style', $draggable.attr('style'))
          .css({left: left, top: top})
        ;

        if (active) $editorControl.addClass('active')
      };

      _this.setPositionForDraggable = function (dataId, $draggableControl) {
        var $draggable = $('.acre__draggable#' + dataId);
        var $draggableCanvas = $draggable.closest('.editor__canvas');

        var left = parseFloat($draggableControl.css('left').replace('/px', ''));
        var top = parseFloat($draggableControl.css('top').replace('/px', ''));
        var bottom = parseFloat($draggableControl.css('bottom').replace('/px', ''));
        var right = parseFloat($draggableControl.css('right').replace('/px', ''));

        var cleft = parseFloat($draggableCanvas.css('left').replace('/px', ''));
        var ctop = parseFloat($draggableCanvas.css('top').replace('/px', ''));
        var cbottom = parseFloat($draggableCanvas.css('bottom').replace('/px', ''));
        var cright = parseFloat($draggableCanvas.css('right').replace('/px', ''));

        left -= cleft;
        top -= ctop;

        $draggable.attr('style', $draggableControl.attr('style')).css({left: left, top: top});
        ;
      };

      _this.createLayerGroup = function (layoutName) {
        var settingsPopover = _.template(templates.settingsPopover);
        var $settingsButton = $('<button class="btn btn-transparent btn-canvas-setting" data-toggle="popover" data-placement="bottom"> Settings <i class="fas fa-cog"></i> </button>');
        $settingsButton.attr('data-content', settingsPopover);

        var layerGroup = _.template(templates.layerGroup);
        var $layerGroup = $(
          layerGroup(
            {
              'layoutClass': layoutName,
              'layoutName': 'Section ' + layoutName[layoutName.length - 1]
            }
          )
        );

        var $layerContainer = $('.editor__layers--container', _this.$modal);
        $layerGroup.assignId();
        $layerGroup.appendTo($layerContainer);

        /**
         * Layers Sortable
         */
        $layerGroup.find('.table__layers-body').sortable({
          items: ".image-editor-layer-row",
          helper: function (e, item) {
            return $(item).clone().addClass('sortable-helper');
          },
          handle: ".btn-order",
          receive: function (event, ui) {

            var layerRow = $(ui.item[0]);
            var $layerGroup = layerRow.closest('.table__layers-list');
            var layout = $layerGroup.attr('data-layout');
            var $canvas = $('.editor__canvas[data-layout="' + layout + '"]');
            var dataId = layerRow.attr('data-row');
            var $draggable = $('#' + dataId);
            var $oldCanvas = $draggable.closest('.editor__canvas');
            var ocTop = parseFloat($oldCanvas.css('top').replace('/px', ''));

            var left = parseFloat($draggable.css('left').replace('/px', ''));
            var top = parseFloat($draggable.css('top').replace('/px', ''));
            var bottom = parseFloat($draggable.css('bottom').replace('/px', ''));
            var right = parseFloat($draggable.css('right').replace('/px', ''));

            $draggable.appendTo($canvas);

            var $newCanvas = $draggable.closest('.editor__canvas');
            var cTop = parseFloat($newCanvas.css('top').replace('/px', ''));
            var cLeft = parseFloat($newCanvas.css('left').replace('/px', ''));

            var nextLength = $newCanvas.nextAll().length
            var prevLength = $newCanvas.prevAll().length;

            var cWidth = $newCanvas.width();
            var cHeight = $newCanvas.height();

            var ocWidth = $oldCanvas.width();
            var ocHeight = $oldCanvas.height();

            var $editorControl = $('.editor__control[data-id=' + dataId + ']', _this.$modal);
            var ecTop = parseFloat($editorControl.css('top').replace('/px', ''));
            var ecLeft = parseFloat($editorControl.css('left').replace('/px', ''));

            var newLayout = $newCanvas.attr('data-layout');
            if (
              newLayout == 'cl-g33_67-l1' ||
              newLayout == 'cl-g33_67-l2' ||
              newLayout == 'cl-g67_33-l1' ||
              newLayout == 'cl-g67_33-l2'
            ) {
              if (nextLength) {
                left = cWidth + left;
              }
              if (prevLength) {
                left = left - ocWidth;
              }
              $draggable.css({left: left});
            }

            if (
              newLayout == 'cl-g50_50-l1' ||
              newLayout == 'cl-g50_50-l2'
            ) {
              if (nextLength) {
                left = cWidth + left;
              }
              if (prevLength) {
                left = left - ocWidth;
              }
              $draggable.css({left: left});
            }

            if (
              newLayout == 'cl-b3-l1' ||
              newLayout == 'cl-b3-l2'
            ) {
              if (nextLength) {
                top = ecTop;
              }
              if (prevLength) {
                top = top - cTop;
              }
              $draggable.css({top: top});
            }

            if (
              newLayout == 'cl-b2-l1' ||
              newLayout == 'cl-b2-l2'
            ) {
              if (nextLength) {
                left = ecLeft;
              }
              if (prevLength) {
                left = left - cLeft;
              }
              $draggable.css({left: left});
            }

            if (
              newLayout == 'cl-b1-l1' ||
              newLayout == 'cl-b1-l2'
            ) {
              if (nextLength) {
                left = ecLeft;
                top = ecTop;
              }
              if (prevLength) {
                left = left - cLeft;
                top = top - cTop;
              }
              $draggable.css({top: top, left: left});
            }

            $editorControl.removeClass('active');
          },
          stop: function (event, ui) {
            _this.setZIndexForDraggableFromLayers();
          },
          placeholder: "sortable-helper",
          connectWith: ".table__layers-body"
        });

        _this.BackgroundLayerRow().checkAndCreateDefaultColorBlock($layerGroup);

        $settingsButton.appendTo($layerGroup.find('.settings-button--container'));
        var $popover = $settingsButton.popover({html: true, container: _this.$modal, 'offset': "100, 0"});
        $popover.on('shown.bs.popover', function (e) {
          var popoverId = $(this).attr('aria-describedby');
          var $layerGroup = $(this).closest('.table__layers-list');
          var $editorLayoutSettings = _this.$modal.find('.popover.show .editor__layouts--settings');
          var $popover = $('#' + popoverId);
          $('.popover', _this.$modal).each(function () {
            if ($(this).attr('id') != popoverId) {
              $(this).remove();
            }
          });
          var $colorPicker = $('[data-colorpicker]', $editorLayoutSettings);
          $colorPicker.assignId();

          var $canvasColor = $(':input[name=canvas-color]', $popover);
          var $range = $(':input[type=range]', $popover);
          var $backgroundImage = $('button.btn-background-image', $popover);

          var layerInfo = _this.BackgroundLayerRow().extractLayerInfo($layerGroup);
          if (typeof layerInfo['images'] != 'undefined') {
            var $bISpan = $backgroundImage.find('span');
            $bISpan.text('Replace Image');
            $backgroundImage.attr('data-action', "replace-background-image");
            $backgroundImage.closest('.editor__layouts--settings').addClass('replace__background--wrapper');
          }
          $canvasColor.val(layerInfo['background']['color']);
          $range.val(layerInfo['background']['opacity']);

          $('[data-colorpicker]', $editorLayoutSettings).colorpicker({
            useAlpha: false, format: 'hex',
            component: '.input-group-append .input-group-text',
          }).on('colorpickerChange colorpickerCreate', function (e) {
            var bc = e.color.toString();
            _this.BackgroundLayerRow().setLayerInfo($layerGroup, {'background': {'color': bc}});
          });

          $('input[type="range"]', $editorLayoutSettings).rangeslider({
            polyfill: false,

            // Default CSS classes
            rangeClass: 'rangeslider',
            disabledClass: 'rangeslider--disabled',
            horizontalClass: 'rangeslider--horizontal',
            verticalClass: 'rangeslider--vertical',
            fillClass: 'rangeslider__fill',
            handleClass: 'rangeslider__handle',
            // Callback function
            onInit: function () {
              //_this.canvas.css({'opacity' :  $(this).val()});
            },

            // Callback function
            onSlide: function (position, value) {
              _this.BackgroundLayerRow().setLayerInfo($layerGroup, {'background': {'opacity': value}});
            },

            // Callback function
            onSlideEnd: function (position, value) {
              _this.BackgroundLayerRow().setLayerInfo($layerGroup, {'background': {'opacity': value}});
            }
          });
        });

        $('.editor__layers--container', _this.$modal).sortable('refresh');

        return $layerGroup;
      };

      _this.canvasStatus = function() {
        return {
          'show' : function(step, total) {
            _this.canvasStatus.clear();
            $('<button class="btn text-green" type="button"> </button>').addClass('canvas-status text-center').text('Building Image '+ parseInt((step * 100/ total)) +'%').appendTo(_this.$modal.find('.canvas-status--wrapper'));
          },
          'clear' : function(){
            $('.canvas-status', _this.$modal).remove();
          }
        }
      }();

      _this.init = function () {
        _this.initModal();
        _this.canvasActions().setCanvasSize();

        window.onbeforeunload = function () {
          _this.saveSessionData();
        };

        /**
         * Layers Group Sortable
         */
        $('.editor__layers--container', _this.$modal).sortable({
          items: "table",
          helper: function (e, item) {
            return $(item).clone().addClass('sortable-helper');
          },
          handle: "th",
          stop: function (event, ui) {
            _this.setZIndexForDraggable();
          },
          start: function (event, ui) {
          },
          placeholder: "sortable-helper"
        });

        var defaultLayout = !_.isEmpty(_this.pageParams().get()) ? _this.pageParams().get()['layout'] : 'basic';
        _this.setLayout(defaultLayout);

        $(document).off('click.editor__social-nav__' + nameSpace).on('click.editor__social-nav__' + nameSpace, context + ' .editor__social-nav .nav-link', function (e) {
          e.stopPropagation();
          $('.editor__social-nav .nav-link').removeClass('active');
          $(this).addClass('active');
          _this.canvasActions().setCanvasSize();
        });

        $(window).off('resize.__' + nameSpace).on('resize.__' + nameSpace, function () {
          _this.canvasActions().setCanvasSize();
        });

        var appImageUploader = new app.ImageUploader({
          'completeCallback': function (modal, response) {
            modal.modal('hide');
            response.images[0].type = 'logo';
            _this.addImage(response);
          }
        });

        var appImageManager = new app.ImageManager({
          'imageSelection': 'single',
          'insertCallback': function (response) {

            var replaceImage = $('.editor__image--toolbar .btn-replace-image', _this.$modal);
            var $layerBackgroundImageBtn = $('.editor__layouts--settings .btn-background-image', _this.$modal);
            var $layerGroup = $('.table__layers-list.active', _this.$modal);
            var dataId, $draggable;
            if ($layerBackgroundImageBtn.hasClass('active')) {
              var $bgImageLayer = $('.image-editor-layer-row.tr-background', $layerGroup);
              dataId = $bgImageLayer.attr('data-row');
              $draggable = $('#' + dataId);
              var $editorControl = $('.editor__control[data-id=' + dataId + ']', _this.$modal);

              response.prepend = true;
              response.background = true;
              response.originalWidth = $draggable.width();
              response.originalLeft = $draggable.css('left');
              response.originalTop = $draggable.css('top');
              $bgImageLayer.remove();

              if ($bgImageLayer.hasClass('background-image')) {
                $draggable.remove();
                $editorControl.remove();
              }

              $('.popover', _this.$modal).remove();

            }
            else if (replaceImage.hasClass('active')) {
              dataId = $('.editor__image--toolbar').attr('data-id');
              $draggable = $('#' + dataId);
              response.originalWidth = $draggable.width();
              $('.image-editor-layer-row[data-row=' + dataId + ']', _this.$modal).find('.btn-trash').trigger('click');
            }

            _this.addImage(response);
            _this.BackgroundLayerRow().checkAndCreateDefaultColorBlock($layerGroup);
            replaceImage.removeClass('active');
          },
          hiddenCallback: function () {
            $('.editor__image--toolbar .btn-replace-image', _this.$modal).removeClass('active');
            $('.editor__layouts--settings .btn-background-image', _this.$modal).removeClass('active');
          }
        });

        $(document).off('click.ie-layer-row__' + nameSpace).on('click.ie-layer-row__' + nameSpace, '.image-editor-layer-row', function (e) {
          e.stopPropagation();
          $('.image-editor-layer-row', _this.$modal).removeClass('active');
          $(this).addClass('active');
          var rowId = $(this).attr('data-row');
          var zIndex = $(this).attr('data-zIndex');
          var $draggable = $('.acre__draggable#' + rowId);
          $draggable.css({'z-index': zIndex}).trigger('click');
        }).off('click.ie-layer-trash__' + nameSpace).on('click.ie-layer-trash__' + nameSpace, '.image-editor-layer-row .btn-trash', function (e) {
          e.stopPropagation();
          var $layerRow = $(this).closest('.image-editor-layer-row');
          var $layerGroup = $layerRow.closest('.table__layers-list');
          var rowId = $layerRow.attr('data-row');
          var $draggable = $('.acre__draggable#' + rowId);
          var $editorControl = $('.editor__control[data-id=' + rowId + ']', _this.$modal);

          $editorControl.remove();
          $draggable.remove();
          $layerRow.remove();

          _this.BackgroundLayerRow().checkAndCreateDefaultColorBlock($layerGroup);
          _this.setZIndexForDraggable();
        }).off('click.background-trash__' + nameSpace).on('click.background-trash__' + nameSpace, ' [data-action="trash-background"]', function (e) {
          e.stopPropagation();
          var popoverId = $(this).closest('.popover').attr('id');
          var $layerGroup = $('button[aria-describedby="' + popoverId + '"]').closest('table');
          var $layerRow = $layerGroup.find('.tr-background');
          var rowId = $layerRow.attr('data-row');
          var $draggable = $('.acre__draggable#' + rowId);
          var $editorControl = $('.editor__control[data-id=' + rowId + ']', _this.$modal);

          $editorControl.remove();
          $draggable.remove();
          $layerRow.find('.col__name').html('');

          $('.popover', _this.$modal).remove();
          $('.editor__image--toolbar', _this.$modal).removeClass('active');
          _this.BackgroundLayerRow().checkAndCreateDefaultColorBlock($layerGroup);
          _this.setZIndexForDraggable();
        });

        $(document) // Actions :: save, download
          .off('click.actions__' + nameSpace).on('click.actions__' + nameSpace, context + ' [data-action]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var action = $(this).attr('data-action'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              imageId = $dataRow.attr('data-row'),
              $context = $(context);

            switch (action) {
              case 'download' :
                $button.button('loading');

                _this.acreCanvas().cleanCanvas();
                var $canvas = _this.acreCanvas().newCanvas(
                  _this.acreCanvas().getLayoutDimensions($('.editor__canvas--container', _this.$modal))
                );
                _this.acreCanvas().generateCanvas($button, $canvas, 0);
                break;
              case 'save' :
                $button.button('loading');
                _this.acreCanvas().cleanCanvas();
                var $canvas = _this.acreCanvas().newCanvas(
                  _this.acreCanvas().getLayoutDimensions($('.editor__canvas--container', _this.$modal))
                );
                _this.acreCanvas().generateCanvas($button, $canvas, 0);
                break;
              case 'add-type' :
                _this.addText($button);
                break;

              case 'add-image':
                appImageManager.show();
                break;

              case 'add-logo':
                appImageUploader.show();
                break;

              case 'edit-layout':
                $('.editor__nav-sec', _this.$modal).removeClass('active');
                if ($(this).hasClass('active')) {
                  $(this).removeClass('active');
                  _this.$modal.removeClass('sec-nav');
                  $('.editor__layouts--container', _this.$modal).removeClass('active');
                } else {
                  $(this).addClass('active');
                  $('.editor__layouts--container', _this.$modal).addClass('active');
                  _this.$modal.addClass('sec-nav');
                }
                $('.editor__nav-main [data-action="edit-layers"]', _this.$modal).removeClass('active');
                break;

              case 'edit-layers' :
                $('.editor__layouts--container', _this.$modal).removeClass('active');
                if ($(this).hasClass('active')) {
                  $(this).removeClass('active');
                  _this.$modal.removeClass('sec-nav');
                  $('.editor__nav-sec', _this.$modal).removeClass('active');
                } else {
                  $(this).addClass('active');
                  _this.$modal.addClass('sec-nav');
                  $('.editor__nav-sec', _this.$modal).addClass('active');
                }

                $('.editor__nav-main [data-action="edit-layout"]', _this.$modal).removeClass('active');
                break;
            }
          }).off('click.canvas__' + nameSpace).on('click.canvas__' + nameSpace, context, function (e) {
            e.stopPropagation();
            if (
              $(e.target).hasClass('editor__body') ||
              $(e.target).hasClass('modal-body')) {
              //$('.editor__canvas', _this.$modal).removeClass('active');
              //_this.canvas = $('.editor__canvas', _this.$modal).eq(0);
              //_this.canvas.addClass('active');
            }

            if (
              $(e.target).hasClass('modal-body') ||
              $(e.target).hasClass('editor__body') ||
              $(e.target).hasClass('editor__canvas')
            ) {
              $('.acre__text').removeAttr('contenteditable');
              $('.editor__control').removeClass('active');
              $('.editor__text--toolbar', _this.$modal).removeClass('active');
              $('.editor__image--toolbar', _this.$modal).removeClass('active');

              _this.canvas.removeClass('overflow-visible');
              $('.popover', _this.$modal).remove();
              $('.popover', _this.$modal).remove();
              $('.dropdown-menu', _this.$modal).removeClass('show');
            }
          }).off('click.canvas_child__' + nameSpace).on('click.canvas_child__' + nameSpace, context + ' .editor__canvas', function (e) {
            e.stopPropagation();
            $('.editor__canvas', _this.$modal).removeClass('active');
            if (!$(this).hasClass('editor__canvas_top')) {
              _this.canvas = $(this);
              _this.canvas.addClass('active');
            }
          })
          .off('click.draggable__' + nameSpace).on('click.draggable__' + nameSpace, context + ' .acre__draggable', function (e) {
            e.stopPropagation();
            var dataId = $(this).attr('id');
            $('.editor__control').removeClass('active');
            _this.setPositionForEditorControl(dataId, $(this));

            $('.image-editor-layer-row', _this.$modal).removeClass('active');
            $('.image-editor-layer-row[data-row=' + dataId + ']', _this.$modal).addClass('active');

          })
          .off('click.editor__control__' + nameSpace).on('click.editor__control__' + nameSpace, context + ' .editor__control', function (e) {
            $('.editor__control').removeClass('active');
            setTimeout(function () {
              var dataId = $('.acre__draggable.hover').attr('id');
              $('.acre__draggable#' + dataId, _this.$modal).trigger('click');
              var $acreText = $('.acre__draggable#' + dataId, _this.$modal).find('.acre__text');
              $acreText.attr('contenteditable', true).focus();
            }, 100);
          }).off('dblclick.editor__control__' + nameSpace).on('dblclick.editor__control__' + nameSpace, context + ' .editor__control', function (e) {
            e.stopPropagation();
            var dataId = $(this).attr('data-id');
            $('.acre__draggable#' + dataId, _this.$modal).find('.acre__text').attr('contenteditable', true).focus();
          })
          .off('input.acre__text__' + nameSpace).on('input.acre__text__' + nameSpace, context + ' .acre__text', function (e) {
            e.stopPropagation();
            var $draggable = $(this).closest('.acre__draggable');
            _this.setDraggableBound($draggable);

          })// Editor controls
          .off('mouseover.editor__control--' + nameSpace).on('mouseover.editor__control--' + nameSpace, context + ' .editor__control, .acre__draggable', function (e) {
            e.stopPropagation();
            $(this).addClass('hover');
          })
          .off('mouseleave.editor__control--' + nameSpace).on('mouseleave.editor__control--' + nameSpace, context + ' .editor__control, .acre__draggable', function (e) {
            e.stopPropagation();
            $(this).removeClass('hover');
          })
          .off('click.layout__options__' + nameSpace).on('click.layout__options__' + nameSpace, context + ' .editor__layouts--container [data-layout]', function (e) {
            e.stopPropagation();
            var layout = $(this).attr('data-layout');
            _this.setLayout(layout);
          });


        _this.getText = function () {
          return _this.getDraggable().find('.acre__text');
        };

        _this.getDraggable = function () {
          var textId = $('.editor__text--toolbar', _this.$modal).attr('data-id');
          return $('#' + textId);
        };

        $(document)
          .off('click.editor__text--toolbar' + nameSpace).on('click.editor__text--toolbar' + nameSpace, '.editor__text--toolbar', function (e) {
            e.stopPropagation();
          })
          .off('click.editor__actions_1' + nameSpace).on('click.editor__actions_1' + nameSpace, context + ' .acre__text--wrapper', function (e) {
            e.stopPropagation();
            $('.editor__image--toolbar', _this.$modal).removeClass('active');
            $('.editor__text--toolbar', _this.$modal).addClass('active').attr('data-id', $(this).attr('id'));
            _this.setEditorSettingsFromText($(this).find('.acre__text'));
          }) // Font Change
          .off('fontChange.editor__actions_2' + nameSpace).on('fontChange.editor__actions_2' + nameSpace, context + ' select[name=editor__fonts]', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            $text.css({'font-family': $(this).val()});
          }) // Font Size
          .off('slideChange.editor__actions_3' + nameSpace).on('slideChange.editor__actions_3' + nameSpace, context + ' :input[name="editor__font-size"]', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            $text.css({'font-size': $(this).val()});
            _this.setDraggableBound(_this.getDraggable());
          }) // Font Color
          .off('changeColor.editor__actions_4' + nameSpace).on('changeColor.editor__actions_4' + nameSpace, context + ' :input[name="text-color"]', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            $text.css({'color': $(this).val()});
          }) // Font Bold
          .off('click.editor__actions_5' + nameSpace).on('click.editor__actions_5' + nameSpace, context + ' :input[name="font__bold"]', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            if ($(this).hasClass('active')) {
              $text.css({'font-weight': 'normal'});
              $(this).removeClass('active');
            } else {
              $text.css({'font-weight': 'bold'});
              $(this).addClass('active');
            }
          }) // Font Italic
          .off('click.editor__actions_6' + nameSpace).on('click.editor__actions_6' + nameSpace, context + ' :input[name="font__italic"]', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            if ($(this).hasClass('active')) {
              $text.css({'font-style': 'normal'});
              $(this).removeClass('active');
            } else {
              $text.css({'font-style': 'italic'});
              $(this).addClass('active');
            }
          })// Font Underline
          .off('click.editor__actions_7' + nameSpace).on('click.editor__actions_7' + nameSpace, context + ' :input[name="font__underline"]', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            if ($(this).hasClass('active')) {
              $text.css({'text-decoration': 'none'});
              $(this).removeClass('active');
            } else {
              $text.css({'text-decoration': 'underline'});
              $(this).addClass('active');
            }
          }) // Line Height
          .off('slideChange.editor__actions_8' + nameSpace).on('slideChange.editor__actions_8' + nameSpace, context + ' :input[name="editor__font-line-height"]', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            $text.css({'line-height': $(this).val()});
            _this.setDraggableBound(_this.getDraggable());
          }) // Letter Spacing
          .off('slideChange.editor__actions_9' + nameSpace).on('slideChange.editor__actions_9' + nameSpace, context + ' :input[name="editor__font-letter-spacing"]', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            $text.css({'letter-spacing': $(this).val()});
            _this.setDraggableBound(_this.getDraggable());
          })// Align Left, Right, Center
          .off('click.editor__actions_10' + nameSpace).on('click.editor__actions_10' + nameSpace, context + ' .btn-align', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            var align = $(this).attr('data-align');
            $('.btn-align', _this.$modal).removeClass('active');
            if ($(this).hasClass('active')) {
              $text.css({'text-align': 'initial'});
            } else {
              $text.css({'text-align': align});
              $(this).addClass('active');
            }
          }).off('click.editor__actions_11' + nameSpace).on('click.editor__actions_11' + nameSpace, context + ' .btn-copy', function (e) {
            e.stopPropagation();
            var $text = _this.getText();
            _this.addDraggable('text', {'text': $text.text()})
          })
          .off('click.editor__actions_12' + nameSpace).on('click.editor__actions_12' + nameSpace, context + ' .editor__text--toolbar .btn-trash', function (e) {
            e.stopPropagation();
            var $draggable = _this.getDraggable();
            var dataId = $draggable.attr('id');
            $('.image-editor-layer-row[data-row=' + dataId + ']', _this.$modal).find('.btn-trash').trigger('click');

            $('.editor__text--toolbar', _this.$modal).removeClass('active');
          }) // :input[data-range]
          .off('change keyup mouseup.editor__actions_13' + nameSpace).on('change keyup mouseup.editor__actions_13' + nameSpace, context + ' :input[data-range]', function (e) {
            e.stopPropagation();
            var $rangeContainer = $(this).closest('.range__container');
            var value = $(this).val();
            $('input[type="range"]', $rangeContainer).val(value).change();
          });


        $(document)
          .off('click.editor__image--toolbar' + nameSpace).on('click.editor__image--toolbar' + nameSpace, '.editor__image--toolbar', function (e) {
            e.stopPropagation();
          })
          .off('click.editor__image--acre__image' + nameSpace).on('click.editor__image--acre__image' + nameSpace, ' .acre__draggable.acre__image', function (e) {
            e.stopPropagation();
            var $replaceImage = $('.editor__image--toolbar', _this.$modal).find('.btn-replace-image');
            var $deleteLogo = $('.editor__image--toolbar', _this.$modal).find('.btn-delete-logo');
            if ($(this).hasClass('acre__logo')) {
              $replaceImage.hide();
              $deleteLogo.show();
            } else {
              $replaceImage.show();
              $deleteLogo.hide();
            }
            $('.editor__text--toolbar', _this.$modal).removeClass('active');
            $('.editor__image--toolbar', _this.$modal).addClass('active').attr('data-id', $(this).attr('id'));
          }).off('click.btn-replace-image' + nameSpace).on('click.btn-replace-image' + nameSpace, '.editor__image--toolbar .btn-replace-image', function (e) {
            $(this).addClass('active');
            appImageManager.show();
          })
          .off('click.editor__image--trash' + nameSpace).on('click.editor__image--trash' + nameSpace, context + ' .editor__image--toolbar .btn-trash', function (e) {
            e.stopPropagation();
            var dataId = $('.editor__image--toolbar', _this.$modal).attr('data-id');
            $('.image-editor-layer-row[data-row=' + dataId + ']', _this.$modal).find('.btn-trash').trigger('click');
            $('.editor__image--toolbar', _this.$modal).removeClass('active');

          });


        $(document) // Layer events
          .off('mouseover.table__layers-list' + nameSpace).on('mouseover.table__layers-list' + nameSpace, context + ' .table__layers-list .table__layers-head ', function (e) {
            e.stopPropagation();
            var $table = $(this).closest('.table__layers-list');
            $table.addClass('hover');

            var canvasLayout = $table.attr('data-layout');
            var $editorCanvas = $('.editor__canvas[data-layout="' + canvasLayout + '"');
            $editorCanvas.addClass('highlight');
            $('.editor__control.active', _this.$modal).css({opacity: 0});
          })
          .off('mouseleave.table__layers-list' + nameSpace).on('mouseleave.table__layers-list' + nameSpace, context + ' .table__layers-list .table__layers-head ', function (e) {
            e.stopPropagation();
            var $table = $(this).closest('.table__layers-list');
            $table.removeClass('hover');

            var canvasLayout = $table.attr('data-layout');
            var $editorCanvas = $('.editor__canvas[data-layout="' + canvasLayout + '"');
            $editorCanvas.removeClass('highlight');
            $('.editor__control.active', _this.$modal).css({opacity: 1});
          })
          .off('click.table__layers-list' + nameSpace).on('click.table__layers-list' + nameSpace, context + ' .table__layers-list .table__layers-head', function (e) {
            e.stopPropagation();
            $('.table__layers-list', _this.$modal).removeClass('active');
            var $table = $(this).closest('.table__layers-list');
            $table.addClass('active');

            $('.editor__canvas', _this.$modal).removeClass('active');
            var canvasLayout = $table.attr('data-layout');
            _this.canvas = $('.editor__canvas[data-layout="' + canvasLayout + '"]', _this.$modal);
            _this.canvas.addClass('active');

          });

        $(document) // Layer Popover events
          .off('click.layer_popover__background-image' + nameSpace).on('click.layer_popover__background-image' + nameSpace, context + ' .editor__layouts--settings .btn-background-image', function (e) {
            $(this).addClass('active');
            e.stopPropagation();
            appImageManager.show();
          })
        ;


        // Modal On show Hide
        _this.$modal.on('shown.bs.modal', function (e) {
          _this.initColorPicker();
          _this.initPopoverAndRangeSlider();
          _this.createFontsDropDown();
        }).on('hidden.bs.modal', function (e) {
          _this.saveSessionData();
          _this.destroy();
          $('.modal-backdrop').remove();
        });

        _this.$modal.modal('show');

        _this.acreCanvas = function () {

          var $canvasRendered = $('.canvas__rendered', _this.$modal);
          var $canvasContainer = $('.editor__canvas--container', _this.$modal);
          var $draggables = $canvasContainer.find('.acre__draggable');
          var $layouts = $canvasContainer.find('.editor__canvas');

          return {
            getLayoutDimensions: function ($layout) {
              var dimension = {
                'w': $layout.width(), 'h': $layout.height(),
                't': $layout.position().top, 'l': $layout.position().left
              };
              return dimension;
            },

            getDraggablesIndex: function ($draggables, $editorCanvas) {
              var indexes = [];
              $draggables.each(function () {
                indexes.push(parseInt($(this).css('z-index')));
              });

              return indexes.sort(function (a, b) {
                return a - b
              });
            },

            getDraggableByIndex: function ($draggables, index) {
              return $draggables.filter(function () {
                return $(this).css('z-index') == index;
              });
            },

            newCanvas: function (canvasDimensions) {
              var $canvas = $('<canvas ></canvas>');
              $canvas.assignId();
              $canvas.attr('width', canvasDimensions['w'] * 2);
              $canvas.attr('height', canvasDimensions['h'] * 2);
              $canvas.css({'width': canvasDimensions['w'], 'height': canvasDimensions['h']});
              $canvasRendered.append($canvas);
              return $canvas;
            },

            cleanCanvas: function () {
              $canvasRendered.find('*').remove();
              $layouts.removeAttr('canvas-id');
            },

            saveCanvas: function ($button, $parentCanvas) {
              if($parentCanvas.height() > 600) {
                $parentCanvas.get(0).toBlob(function (blob) {
                  var canvasDimensions = {'w': $parentCanvas.width() / 2, 'h': $parentCanvas.height() / 2};
                  var $newCanvas = _this.acreCanvas().newCanvas(canvasDimensions),
                    $newCanvasContext = $newCanvas.get(0).getContext('2d');
                  $newCanvasContext.drawImage($parentCanvas.get(0), 0, 0, canvasDimensions['w']*2, canvasDimensions['h'] *2);

                  $newCanvas.get(0).toBlob(function (blob) {
                    var image = $newCanvas.get(0).toDataURL('image/jpeg').replace(/^data:image\/(png|jpeg);base64,/, '');
                    $.when(_this.imageActions().save({image: image})).done(function (response) {
                      $button.button('reset');
                      if (_this.options.insertCallback) {
                        _this.options.insertCallback(response);
                      }
                      // Download
                      if ($button.attr('data-action') == 'download') {
                        window.open(response.path, '_blank');
                      }
                    }).fail(function () {
                      $button.button('reset');
                    });
                  });
                });
              } else {
                $parentCanvas.get(0).toBlob(function (blob) {
                  var image = $parentCanvas.get(0).toDataURL('image/jpeg').replace(/^data:image\/(png|jpeg);base64,/, '');
                  $.when(_this.imageActions().save({image: image})).done(function (response) {
                    $button.button('reset');
                    if (_this.options.insertCallback) {
                      _this.options.insertCallback(response);
                    }
                    // Download
                    if ($button.attr('data-action') == 'download') {
                      window.open(response.path, '_blank');
                    }
                  }).fail(function () {
                    $button.button('reset');
                  });
                });
              }
            },

            generateCanvas: function ($button, $parentCanvas, stepIndex) {
              var $layoutCanvas, layoutCanvasId, $layoutCanvasContext,
                $parentCanvasContext = $parentCanvas.get(0).getContext('2d');

              if (stepIndex == $draggables.length) {
                _this.canvasStatus.clear();
                _this.acreCanvas().saveCanvas($button, $parentCanvas);
                return false;
              }

              _this.canvasStatus.show(stepIndex, $draggables.length);

              $draggables.attr('data-html2canvas-ignore', true);
              $layouts.attr('data-html2canvas-ignore', true);
              var zIndex = _this.acreCanvas().getDraggablesIndex($draggables)[stepIndex];
              var $draggable = _this.acreCanvas().getDraggableByIndex($draggables, zIndex);

              var $layout = $draggable.closest('.editor__canvas'),
                canvasDimensions = _this.acreCanvas().getLayoutDimensions($layout);

              if (layoutCanvasId = $layout.attr('canvas-id')) {
                $layoutCanvas = $('canvas#' + layoutCanvasId);
              } else {
                $layoutCanvas = _this.acreCanvas().newCanvas(canvasDimensions);
                $layout.attr('canvas-id', $layoutCanvas.attr('id'));
              }

              $layoutCanvasContext = $layoutCanvas.get(0).getContext('2d');

              $layout.removeAttr('data-html2canvas-ignore');
              $draggable.removeAttr('data-html2canvas-ignore');

              var options = {
                backgroundColor: null,
                width: canvasDimensions['w'],
                height: canvasDimensions['h'],
                scale: 2,
                imageTimeout: 0,
                logging: false,
                windowWidth: 1400,
                windowHeight: 800
              };

              html2canvas($layout.get(0), options).then(function (canvas) {
                _this.acreCanvas().generateCanvas($button, $parentCanvas, ++stepIndex);
                $layoutCanvasContext.drawImage(canvas, 0, 0);
                $parentCanvasContext.drawImage($layoutCanvas.get(0), canvasDimensions['l'] * 2, canvasDimensions['t'] * 2);
              }).catch(function (error) {
                /* This is fired when the promise executes without the DOM */
                console.log(error);
              });

            }

          }
        };

        _this.imageActions = function () {
          return {
            save: function (requestData) {
              var query = $.Deferred();
              var appTransport = app.transport();
              requestData = _this.prepareRequest(requestData);

              appTransport
                .setEvent('onSuccess', function (response) {
                  if (_.isEmpty(response)) {
                    app.flashMessenger('error', 'Empty response');
                    return query.reject(response);
                  } else {
                    $(':input[name=id]', _this.$modal).val(response.id);

                    app.flashMessenger('success', response.message);
                    return query.resolve(response);
                  }
                })
                .setEvent('onError', function (error) {
                  app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                  return query.reject(error);
                })
                .setEvent('onComplete', function () {

                })
              ;
              appTransport.post('/api/image/save', requestData);
              return query.promise();
            }
          }
        };

      };


      return {
        show: function () {
          _this.pageParams().clear();
          if (_this.options.canvasData) {
            _this.pageParams().set(_this.options.canvasData);
          }
          _this.init();
          if (_this.options.id && !_.isNull(_this.options.id)) {
            $(':input[name=id]', _this.$modal).val(_this.options.id);
          }
        }
      };
    };
  });
})(PreBuilt);
